export const addMoveListener = (
  callback: (coordinates: [number, number]) => void,
  pointerDownPosition: [number, number],
  interactiveDirection: 'vertical' | 'horizontal' | 'both'
) => {
  let isFirstMove = true

  const touchMoveHandler = (e: TouchEvent) => {
    const x = e.touches[0].clientX - pointerDownPosition[0]
    const y = e.touches[0].clientY - pointerDownPosition[1]

    let direction: 'vertical' | 'horizontal' = 'horizontal'

    if (isFirstMove) {
      direction = (Math.atan2(Math.abs(x), Math.abs(y)) * 180) / Math.PI < 45 ? 'vertical' : 'horizontal'
      isFirstMove = false
      if ((interactiveDirection !== direction && interactiveDirection !== 'both') || e.touches.length > 1) {
        document.removeEventListener('touchmove', touchMoveHandler)
        return
      }
    }

    e.preventDefault()
    callback([e.touches[0].clientX, e.touches[0].clientY])
  }

  const mouseMoveHandler = (e: MouseEvent) => {
    const x = e.clientX - pointerDownPosition[0]
    const y = e.clientY - pointerDownPosition[1]

    let direction: 'vertical' | 'horizontal' = 'horizontal'

    if (isFirstMove) {
      direction = (Math.atan2(Math.abs(x), Math.abs(y)) * 180) / Math.PI < 45 ? 'vertical' : 'horizontal'
      isFirstMove = false
      if (interactiveDirection !== direction && interactiveDirection !== 'both') {
        document.removeEventListener('mousemove', mouseMoveHandler)
        return
      }
    }

    callback([e.clientX, e.clientY])
  }

  document.addEventListener('touchmove', touchMoveHandler, { passive: false })
  document.addEventListener('mousemove', mouseMoveHandler)

  return () => {
    document.removeEventListener('touchmove', touchMoveHandler)
    document.removeEventListener('mousemove', mouseMoveHandler)
  }
}
